<template>
    <div class="bg-white shadow rounded-md px-4 py-5 sm:p-6 mb-5">
        <h4 class="text-gray-700 font-medium">Método de pago</h4>
        <p class="text-gray-600 mb-6">Mantén actualizado tu método de pago.</p>
        <div>
            <table class="w-full flex sm:table flex-row flex-no-wrap overflow-hidden">
                <thead class="hidden sm:table-header-group">
                    <tr class="bg-gray-200 flex flex-col flex-no wrap sm:table-row">
                        <th class="font-normal text-sm p-3 text-left">Titular</th>
                        <th class="font-normal text-sm p-3 text-left">Forma de pago</th>
                        <th class="font-normal text-sm p-3 text-left">Número de tarjeta</th>
                        <th class="font-normal text-sm p-3 text-left rounded-r">Fecha de activación</th>
                        <th class="font-normal text-sm p-3 text-left rounded-l"></th>
                    </tr>
                </thead>
                <tbody class="flex-1 sm:flex-none sm:border-t-12 sm:border-white">
                    <tr
                        class="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0"
                        v-for="(card, index) in visibleCards"
                    >
                        <td class="text-sm sm:p-3 py-1">{{ card.name }}</td>
                        <td class="text-sm sm:p-3 py-1">{{ card.presentable_type }}</td>
                        <td class="text-sm sm:p-3 py-1">{{ card.presentable_number }}</td>
                        <td class="text-sm sm:p-3 pt-1">{{ card.presentable_created_at }}</td>
                        <td class="text-sm sm:p-3 pt-1 pb-5">
                            <form @submit.prevent="onDelete(index)">
                                <button
                                    type="submit"
                                    class="btn text-green-500 border border-green-500 hover:bg-green-500 hover:text-white md:inline-block block md:w-auto w-full"
                                >
                                    Borrar
                                </button>
                            </form>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="flex mt-5">
                <button
                    type="button"
                    class="btn btn-primary md:inline-block block md:w-auto w-full mr-2"
                    @click="toggleHidden"
                >
                    Agregar
                </button>
            </div>
            <div id="div_payment_form" :class="{ hidden: isHidden }">
                <form @submit.prevent="onSubmit" class="mt-6" @keydown="form.errors.clear($event.target.name)">
                    <div class="grid sm:grid-cols-2 gap-6">
                        <div>
                            <label class="block text-sm font-medium leading-5 text-gray-700"
                                >Nombre como aparece en la tarjeta</label
                            >
                            <input
                                type="text"
                                name="name"
                                class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                size="191"
                                v-model.trim="form.name"
                            />
                            <span
                                class="invalid-feedback"
                                v-if="form.errors.has('name')"
                                v-text="form.errors.get('name')"
                            ></span>
                        </div>
                        <div>
                            <label class="block text-sm font-medium leading-5 text-gray-700">Tipo de tarjeta</label>
                            <select
                                id="card_type"
                                name="card_type"
                                class="appearance-none w-full bg-white text-gray-600 block pl-2 pr-6 py-2 mt-1 text-center leading-tight border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300"
                                v-model="form.type"
                            >
                                <option selected disabled value="">Seleccionar</option>
                                <option value="credit">Crédito</option>
                                <option value="debit">Débito</option>
                            </select>
                            <span
                                class="invalid-feedback"
                                v-if="form.errors.has('type')"
                                v-text="form.errors.get('type')"
                            ></span>
                        </div>
                        <div>
                            <label class="block text-sm font-medium leading-5 text-gray-700">Número de tarjeta</label>
                            <input
                                type="text"
                                name="number"
                                class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                size="16"
                                v-model="form.number"
                            />
                            <span
                                class="invalid-feedback"
                                v-if="form.errors.has('number')"
                                v-text="form.errors.get('number')"
                            ></span>
                        </div>
                        <div>
                            <label class="block text-sm font-medium leading-5 text-gray-700"
                                >Fecha de expiración (MM/AAAA)</label
                            >
                            <div class="grid grid-cols-2 gap-3">
                                <div>
                                    <input
                                        type="text"
                                        name="month"
                                        class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        size="2"
                                        v-model="form.month"
                                    />
                                </div>
                                <div>
                                    <input
                                        type="text"
                                        name="year"
                                        class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        size="4"
                                        v-model="form.year"
                                    />
                                </div>
                            </div>
                            <span class="invalid-feedback" v-if="form.errors.has('month') || form.errors.has('year')">
                                {{ form.errors.get('month') }}<br />{{ form.errors.get('year') }}
                            </span>
                        </div>
                        <div>
                            <label class="block text-sm font-medium leading-5 text-gray-700">CVV</label>
                            <input
                                type="text"
                                name="cvv"
                                class="mt-1 form-input block w-full py-2 px-3 border border-gray-300 rounded-md focus:ring-opacity-30 focus:border-green-300 focus:outline-none focus:ring focus:ring-green-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                size="4"
                                v-model="form.cvv"
                            />
                            <span
                                class="invalid-feedback"
                                v-if="form.errors.has('cvv')"
                                v-text="form.errors.get('cvv')"
                            ></span>
                        </div>
                    </div>
                    <button
                        type="submit"
                        class="btn font-medium text-sm md:inline-block block md:w-auto w-full border border-gray-400 shadow bg-white hover:shadow-md focus:shadow-md text-gray-700 mt-6"
                        :disabled="loading"
                    >
                        Guardar
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import Form from '../support/Form';
import sweetAlert from 'sweetalert';

export default {
    props: {
        cards: { required: true },
    },

    data() {
        return {
            loading: false,
            isHidden: true,
            form: new Form({
                name: '',
                type: '',
                number: '',
                month: '',
                year: '',
                cvv: '',
            }),
            visibleCards: this.cards,
        };
    },

    methods: {
        onSubmit() {
            this.loading = true;

            this.form
                .submit('post', '/cards')
                .then((response) => {
                    sweetAlert('Éxito', 'Tarjeta agregada exitosamente.', 'success');
                    this.cards.push(response.card);
                    this.loading = false;
                    this.isHidden = true;
                })
                .catch((error) => (this.loading = false));
        },

        onDelete(index) {
            axios
                .post('/cards/' + this.cards[index].id, { _method: 'delete' })
                .then((response) => {
                    this.visibleCards.splice(index, 1);
                    sweetAlert('Éxito', 'Tarjeta borrada exitosamente.', 'success');
                })
                .catch((error) => sweetAlert('Error', 'Hubo un problema.', 'error'));
        },

        toggleHidden() {
            this.isHidden = !this.isHidden;
        },
    },
};
</script>

<style></style>
